import { render, staticRenderFns } from "./DevOverrideGeneratedAt.vue?vue&type=template&id=2a374f46&"
import script from "./DevOverrideGeneratedAt.vue?vue&type=script&lang=ts&"
export * from "./DevOverrideGeneratedAt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports